import React, { Component } from 'react';
// import styled from 'styled-components'
import { Link } from 'react-router-dom'
import { Layout, Menu, Button } from 'antd';
import "./home.scss"
import GodelImg from '../../asset/images/Godel.png';
import EinsteinImg from '../../asset/images/Einstein.png';
import TuringImg from '../../asset/images/Turing.png';

// Import mock util (using relative path within src)
import { apiUtil as Util } from '../../mock/mockServices';

// Mock localStorage if not available
if (typeof localStorage === 'undefined' || localStorage === null) {
  // 创建一个空的localStorage模拟对象，而不是填充默认用户信息
  Object.defineProperty(window, 'localStorage', {
    value: {
      _data: {},
      setItem: function(id, val) { return this._data[id] = String(val); },
      getItem: function(id) { return this._data.hasOwnProperty(id) ? this._data[id] : undefined; },
      removeItem: function(id) { return delete this._data[id]; },
      clear: function() { return this._data = {}; }
    },
    writable: true
  });
}

const { Header, Content } = Layout;
// const background = require('../../asset/images/background.png')
const logoName = require('../../asset/images/logo_name.png')
const logoBig = require('../../asset/images/logo.png')
const imageTulin = require('../../asset/images/tulin.png')

export default class HomeIndex extends Component {

  state = {
    getTipHover: false,
    tulinTipHover: false,
    personHover: null // 'godel', 'einstein', 'turing'
    // userType: 'user' // 'user', 'admin', 'sysadmin'
  }

  changeGetStatus = show => {
    console.log(show);
    
    this.setState({
      getTipHover: show
    })
  }

  changeTulinStatus = show => {
    this.setState({
      tulinTipHover: show
    });
  }

  logout = () => {
    Util.ajax.post('/common/loginOut').then(res => {
      window.location.href = '/login'
    })
  }

  componentDidMount() {
    // 只有在用户已登录的情况下才获取用户类型
    if (localStorage.authToken && localStorage.authToken !== 'mock_auth_token' && localStorage.authUserName) {
      Util.ajax.get('/common/user/' + localStorage.authUserId)
        .then(res => {
          // For mock purposes, determine user type based on orgId
          let userType = 'user';
          if (res.data.orgId === 'org_000' || res.data.userType === 'sysadmin') {
            userType = 'sysadmin';
          } else if (res.data.userType === 'admin') {
            userType = 'admin';
          }
          
          this.setState({ 
            userType: userType
          });
        })
        .catch(error => {
          // Even on error, we can set admin status for mock purposes
          this.setState({ 
            userType: 'sysadmin'
          });
        });
    }
  }

  handleMenuClick = (route) => {
    if (!localStorage.authUserName) {
      this.props.history.push('/login');
    } else {
      this.props.history.push(route);
    }
  }

  render() {
    // const { userType } = this.state;
    
    return <div className="home-page">
      <Header className="header">
        <div className="logo" ><img src={logoName} alt="" /></div>
        <Menu theme="light" mode="horizontal" selectedKeys={['home']}>
          <Menu.Item key="home"><Link to="/">Home</Link></Menu.Item>
          <Menu.Item key="train" onClick={() => this.handleMenuClick('/train')}>Train</Menu.Item>
          <Menu.Item key="predict" onClick={() => this.handleMenuClick('/predict')}>Predict</Menu.Item>
          {/* 注释掉用户管理菜单项，后续重新设计用户体验 */}
          {/* {(userType === 'admin' || userType === 'sysadmin') && (
            <Menu.Item key="user" onClick={() => this.handleMenuClick('/orgUserList')}>Organization User Management</Menu.Item>
          )} */}
          {/* 注释掉系统管理菜单项，后续重新设计用户体验 */}
          {/* {userType === 'sysadmin' && (
            <Menu.Item key="system" onClick={() => this.handleMenuClick('/orgList')}>System Management</Menu.Item>
          )} */}
        </Menu>

        <div className="login-user_info">
          {/* <Dropdown className="mr30" overlay={
            <Menu onClick={this.handleClick}>
              <Menu.Item key="dw">
                <Link to="/dwConfig">Data Resource Configuration</Link>
              </Menu.Item>
              <Menu.Item key="running">
                <Link to="/running">Offline Task Management</Link>
              </Menu.Item>
            </Menu>
          }>
            <span className="ant-dropdown-link">System Configuration</span>
          </Dropdown> */}
          <Button type="link" className="mr20" size="small" onClick={() => window.open('DLM_GET_Algo_System.pdf')}>G.E.T Insights</Button>
          {localStorage.authUserName && <span>
            <div className="name-button">{localStorage.authUserName}</div>
            <i className="iconfont logout ml15" onClick={this.logout}>&#xe605;</i>
          </span>
          }
          {!localStorage.authUserName && <Button type="danger" size="small" ghost onClick={() => this.props.history.push('/login')}>Login</Button>
          }
        </div>
      </Header>
      <Content>
        <div className="split-text">
          <div className="left">Innovation Beyond</div>          <div className="right">Tribute to Classics</div>
        </div>
        <div className="get">
          <div className="content">
            <div className={'target-get' + (this.state.tulinTipHover ? ' hide' : '')}>
              <div className='logo-big' onMouseEnter={() => this.changeGetStatus(true)} onMouseLeave={() => this.changeGetStatus(false)}>
                <img src={logoBig} alt="get-logo"/>
              </div>
              <div className="title">G.E.T System</div>
            </div>
            <div className="tip">
              <p>A cutting-edge technology startup incorporated in Delaware of the USA, G.E.T Algo System Inc. is committed to delivering the next-generation deep learning techniques to revolutionize the financial service industries.</p>
            </div>
            
            <div className="tip">
              <p>G.E.T System provides:</p>
              <p>- a ground-breaking architecture that provides complete transparency of artificial neural systems.</p>
              <p>- a state-of-the-art interpretable AI solution for financial modeling.</p>
              <p>- a super safe A(G)I system for financial management.</p>
            </div>
          </div>
        </div>
        <div className="tulin">
          <div className="content">
            <div className={'target-tulin' + (this.state.getTipHover ? ' hide' : '')}>
              <div className="tulin-comp"
  onMouseEnter={() => this.changeTulinStatus(true)}
  onMouseLeave={() => this.changeTulinStatus(false)}
>
                <img src={imageTulin} alt="Turing Computer"/>
              </div>
              <div className="title">Turing Machine</div>
              {/* Add images below Turing Machine title */}
              <div className="tip"></div>
                {/* <div className="title">G/E/T Portraits:</div> */}
              
                <div className="person-row">
                  <div className="person-img">
                    <img src={GodelImg} alt="Godel" onMouseEnter={() => this.setState({personHover: 'godel'})} onMouseLeave={() => this.setState({personHover: null})}/>
                  </div>
                  <div className="person-img">
                    <img src={EinsteinImg} alt="Einstein" onMouseEnter={() => this.setState({personHover: 'einstein'})} onMouseLeave={() => this.setState({personHover: null})}/>
                  </div>
                  <div className="person-img">
                    <img src={TuringImg} alt="Turing" onMouseEnter={() => this.setState({personHover: 'turing'})} onMouseLeave={() => this.setState({personHover: null})}/>
                </div>
              </div>
            </div>
          </div>
        </div>
        <div className={'hover-popup get-popup' + (this.state.getTipHover ? ' active' : '')}>
          <div className="tip-box-outer">
            <div className="tip-box-inner">
              <div className="title">G.E.T Algo System's View</div>
              <div className="time">· January 28, 2022 ·</div>
              <div className="line"></div>
              <div className="content">
                The only definitive feature of 'artificial intelligence' as a machine intelligence is the transparency of its making to human beings. Therefore, a technique that is essential to develop AI needs to possess the capability of giving full disclosure on how the performance based on AI is driven out by man-made algorithms in exact. Only by fulfilling that goal, human beings would make AI a meaningful technological advance to their world.
              </div>
              <p></p>
              <div className="content">
                Resolving the Undecidability, January 2022, Guang Guo and Max Guo
( https://papers.ssrn.com/sol3/papers.cfm?abstract_id=4034285 )
              </div>
            </div>
            <div className="circle left-top"></div>
            <div className="circle right-top"></div>
            <div className="circle left-bottom"></div>
            <div className="circle right-bottom"></div>
          </div>
        </div>
        <div
  className={'hover-popup tulin-popup' + (this.state.tulinTipHover ? ' active' : '')}
  onMouseEnter={() => this.changeTulinStatus(true)}
  onMouseLeave={() => this.changeTulinStatus(false)}
>
          <div className="tip-box-outer">
            <div className="tip-box-inner">
              <div className="title">Turing's paper 'On Computable Numbers, with an Application to the Entscheidungsproblem'</div>
              <div className="time">· May 28, 1936 ·</div>
              <div className="line"></div>
              <div className="content">
              The mathematical problem of 'computability' asks whether, given enough time, a mathematician can arrive at a final answer through a finite number of simple, mechanical steps? Turing addressed this complex mathematical and philosophical question. In 1936, he published his paper 'On Computable Numbers, with an Application to the Entscheidungsproblem', where he ingeniously conceived of a 'computer' entirely in the realm of imagination, which mathematicians call the 'Turing Machine'.
              <br/><br/>
              The 'Turing Machine' imagines an infinitely long tape, where the '0's and '1's represent the steps in solving a specific mathematical problem. The 'Turing Machine' can recognize each step in the process, methodically executing a series of operations until the answer is obtained.
                <br/><br/>
                Years later, American researchers Atanasoff and Berry created the world's first electronic computer, the ABC, which used binary code, where the opening and closing of circuits represented the numbers '0' and '1'. In the 1940s, John von Neumann developed an even better electronic computer, designed coding programs for computers, and implemented the use of paper tape for storage and input. At this point, the genius Turing's scientific foresight and ideas published in 1936 were fully realized.
                <br/><br/>
                The 'Turing Machine' established the first link between pure mathematical symbolic logic and the physical world. The computers and 'artificial intelligence' we know today are all based on this concept.
              </div>
            </div>
            <div className="circle left-top"></div>
            <div className="circle right-top"></div>
            <div className="circle left-bottom"></div>
            <div className="circle right-bottom"></div>
          </div>
        </div>
        {/* Person popups */}
        <div className={'hover-popup person-popup turing-popup' + (this.state.personHover === 'godel' ? ' active' : '')}>
          <div className="tip-box-outer">
            <div className="tip-box-inner">
              <div className="title">Godel</div>
              <div className="line"></div>
              <div className="content">
                a ground-breaking architecture that provides complete transparency of formal logic systems.
              </div>
            </div>
            <div className="circle left-top"></div>
            <div className="circle right-top"></div>
            <div className="circle left-bottom"></div>
            <div className="circle right-bottom"></div>
          </div>
        </div>
        <div className={'hover-popup person-popup turing-popup' + (this.state.personHover === 'einstein' ? ' active' : '')}>
          <div className="tip-box-outer">
            <div className="tip-box-inner">
              <div className="title">Einstein</div>
              <div className="line"></div>
              <div className="content">
                a state-of-the-art analytic framework to model gravitational force in time-space domain.
              </div>
            </div>
            <div className="circle left-top"></div>
            <div className="circle right-top"></div>
            <div className="circle left-bottom"></div>
            <div className="circle right-bottom"></div>
          </div>
        </div>
        <div className={'hover-popup person-popup turing-popup' + (this.state.personHover === 'turing' ? ' active' : '')}>
          <div className="tip-box-outer">
            <div className="tip-box-inner">
              <div className="title">Turing</div>
              <div className="line"></div>
              <div className="content">
                a universal Automatic Computing Engine to perform logical operations.
              </div>
            </div>
            <div className="circle left-top"></div>
            <div className="circle right-top"></div>
            <div className="circle left-bottom"></div>
            <div className="circle right-bottom"></div>
          </div>
        </div>
        <div className="footer">G.E.T Algo System Copyright ©2025 G.E.T All Rights Reserved.</div>
      </Content>
    </div>
  }
}